
class SelectInput {

  constructor($compile) {

      this.$compile = $compile;

      return {
          restrict: 'E',
          templateUrl: 'forms/select-input.html',
          compile: function (Elem, Attrs) {
              var keysToCopy = [
                'ngModel',
                'placeholder',
                'name',
                'label',
                'pattern',
                'required',
                'minlength',
                'maxlength',
                'readonly',
                'disabled'
              ];
              var $label = Elem.find('label');
              var $select = Elem.find('select');

              // copy attrs to the select
              Object.keys(Attrs).forEach(
                  function (key) {
                    if (keysToCopy.indexOf(key) > -1) {
                      
                      $select.attr(_.kebabCase(key), Attrs[key] || 1);
                    }
                  }
              );

              //add label and id
              if (Attrs['label']) $label.text(Attrs['label']);
              if (Attrs['name']) $label.attr('for', Attrs['name']);

              //sort select options
              if (Attrs['fullOptions']) {

                $select.attr({'ng-options': Attrs['fullOptions']});
                
              } else if (Attrs['options']) {

                $select.attr({'ng-options': 'item.id as item.name for item in ' + Attrs['options']});
              }

          }
      };

  }

}


angular.module('cpm')
  .directive('selectInput', () => {
      'use strict';
      return new SelectInput();
  });
